import { render, staticRenderFns } from "./ProgressCosts.vue?vue&type=template&id=22b0c52c&scoped=true&"
import script from "./ProgressCosts.vue?vue&type=script&lang=js&"
export * from "./ProgressCosts.vue?vue&type=script&lang=js&"
import style0 from "./ProgressCosts.vue?vue&type=style&index=0&id=22b0c52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0c52c",
  null
  
)

export default component.exports